var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{attrs:{"name":"header"}}),(_vm.isShow)?_c('router-view'):_vm._e(),_c('router-view',{attrs:{"name":"footer"}}),_c('loginStatus'),_c('helpStatus'),_c('tipleStatus'),_c('delStatus')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }